import { FC } from 'react';
import type { HeaderItemPropsTypes } from './types/propsTypes';
import styles from './HeaderItem.module.scss';

const HeaderItem: FC<HeaderItemPropsTypes> = ({ headerItemIcon }) => (
  <>
    <li className={styles['side-navigation-items']} data-testid="headerItem-test-id">
      {headerItemIcon}
    </li>
  </>
);

export default HeaderItem;
